import { Box, Typography } from "@mui/material";

export default function AboutUs() {
    return (
        <Box sx={{display:"flex", justifyContent:"center",alignItems:"center", height:"80vh"}}>
            <Typography sx={{fontSize:"200px"}}>About Us</Typography>
        </Box>
    );
}
